import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const AccordionLeft = ({ open, title, description, body, insideMode, keepContent = false, disabled = false, onClick }) => {
  return (
    <>
      <div
        className={`accordion ${open ? 'accordion--show' : ''} ${insideMode ? 'accordion--with-border' : ''} ${
          insideMode && open ? 'accordion--with-border-open' : ''
        }`}
        onClick={e => !disabled && onClick(e)}
      >
        <div
          className={`accordion__arrow ${open ? 'accordion__arrow--show' : ''} ${disabled ? 'accordion__disabled' : ''}`}
          alt="arrow"
        />
        <div className={`accordion__title ${disabled ? 'accordion__title--disabled' : ''}`}>{title}</div>
        <div className="accordion__desc">{description}</div>
      </div>
      <div
        className={`accordion-body ${open ? 'accordion-body--show' : 'accordion-body--hidden'} ${
          insideMode ? 'accordion-body--inside-mode' : ''
        }`}
      >
        {keepContent ? body : open ? body : <></>}
      </div>
    </>
  );
};

AccordionLeft.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  body: PropTypes.object,
  insideMode: PropTypes.bool,
  keepContent: PropTypes.bool,
  onClick: PropTypes.func,
};

export default AccordionLeft;
